module.exports = __webpack_public_path__ + "img/4063499ffa434171b9a7e5284aee0c32.png";